export enum Gender {
    woman = 'woman',
    man = 'man'
}